<template>
  <header class="header">
    <nav>
      <router-link to="/" class="logo"></router-link>
      <ul>
        <li>
          <router-link to="/about" class="nav-link"><h3>About</h3></router-link>
        </li>
        <li>
          <router-link to="/work" class="nav-link"><h3>Work</h3></router-link>
        </li>
        <li>
          <router-link to="/contact" class="nav-link"
            ><h3>Contact</h3></router-link
          >
        </li>
      </ul>
      <div class="icons">
        <!-- <a href="#!">
                    <i class="fab fa-twitter fa-2x"></i>
                </a> -->
        <a href="https://www.facebook.com/SterLloyd/">
          <i class="fab fa-facebook fa-2x"></i>
        </a>
        <a href="https://www.instagram.com/bsterling604/">
          <i class="fab fa-instagram fa-2x"></i>
        </a>
        <a href="https://www.linkedin.com/in/brian-sterling-b02b3214/">
          <i class="fab fa-linkedin fa-2x"></i>
        </a>
        <!-- <a href="https://github.com/sterling000">
                    <i class="fab fa-github fa-2x"></i>
                </a> -->
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/config.scss";

.header {
  height: 12vh;
}

nav {
  height: 127px;
  width: 100%;
  text-align: left;
}

ul * {
  list-style: none;
  display: inline;
}

.nav-link {
  color: set-text-color($primary-color);
  text-transform: uppercase;
  text-decoration: none;
  font-size: 24px;
  font-weight: bold;
  margin: 1rem;
  cursor: pointer;
  position: relative;
  top: 2rem;
  left: 1rem;
  padding: 0 1rem;
  letter-spacing: 0.15rem;
}

.logo {
  background: url("../assets/Logo.svg");
  width: 330px;
  height: 83px;
  float: left;

  margin-left: 5rem;
  margin-right: 40px;
}

.icons {
  margin-top: 0.6rem;
  margin-right: 5rem;
  text-align: right;
  text-decoration-color: set-text-color($primary-color);
  a {
    padding: 0.4rem;
    @include easeOut;
    &:hover {
      color: $secondary-color;
    }
  }
}
@import "../assets/styles/mobile.scss";
</style>
